// VersionWatcher — „live refresh" aplikacji web. Wykrywa nowe wdrożenie (zmiana
// hashy w /asset-manifest.json generowanym przez CRA przy buildzie) i automatycznie
// przeładowuje stronę, żeby nowa wersja weszła BEZ ręcznego odświeżania.
//
// Bezpieczeństwo pracy operatora: przeładowanie jest ODKŁADANE w trakcie aktywnej
// sesji pakowania (ścieżka /packing-station/session) oraz gdy ustawiono globalną
// flagę zajętości (window.__packflowBusy). Po opuszczeniu sesji / odzyskaniu
// widoczności karty próba ponawiana. Dane „na żywo" zapewnia react-query
// (refetchInterval w tle + refetch po fokusie/reconnect) — tu chodzi o KOD aplikacji.

const POLL_MS = 60_000;
const MANIFEST_URL = `${process.env.PUBLIC_URL || ''}/asset-manifest.json`;

let baseline: string | null = null;
let pendingReload = false;
let started = false;

declare global {
  interface Window {
    __packflowBusy?: boolean;
  }
}

function isDev(): boolean {
  const h = typeof window !== 'undefined' ? window.location.hostname : '';
  return h === 'localhost' || h === '127.0.0.1';
}

async function fetchSignature(): Promise<string | null> {
  try {
    const res = await fetch(`${MANIFEST_URL}?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    const json = await res.json();
    // entrypoints to lista plików wejściowych z contenthashem — stabilny podpis builda.
    const sig = json.entrypoints || json.files?.['main.js'] || json.files;
    return sig ? JSON.stringify(sig) : null;
  } catch {
    return null;
  }
}

function reloadAllowedNow(): boolean {
  if (window.__packflowBusy) return false;
  // Nie przerywaj aktywnej sesji pakowania (skanowanie/etykiety).
  if (window.location.pathname.includes('/packing-station/session')) return false;
  return true;
}

function tryReload() {
  if (!pendingReload) return;
  if (!reloadAllowedNow()) return; // spróbujemy ponownie później / po zmianie widoku
  window.location.reload();
}

async function check() {
  const sig = await fetchSignature();
  if (!sig) return;
  if (baseline === null) {
    baseline = sig;
    return;
  }
  if (sig !== baseline) {
    pendingReload = true;
    tryReload();
  }
}

export function installVersionWatcher(): void {
  if (started || typeof window === 'undefined' || isDev()) return;
  started = true;

  check();
  setInterval(check, POLL_MS);

  // Karta wraca na pierwszy plan / sieć wraca → sprawdź wersję i spróbuj przeładować.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      tryReload();
      check();
    }
  });
  window.addEventListener('online', check);

  // Po nawigacji (np. wyjście z sesji pakowania) dokończ odłożone przeładowanie.
  window.addEventListener('popstate', tryReload);
  window.addEventListener('packflow:route-changed', tryReload as EventListener);
  setInterval(tryReload, 15_000);
}
